<template>
  <div class="personal_study_record">
    <h2 class="title_com">{{ title }}</h2>
    <section class="pd2430">
      <!-- 表格 -->
      <RersouceStudyRecordTB
        :list="rersouceStudyRecordArr"
      ></RersouceStudyRecordTB>
      <!-- 分页 -->
      <Pagination
        :currentPage="currentPage2"
        :pageSize="pageSize2"
        :total="total2"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage2"
        @changeSize="changeSize2"
        v-if="total2 !== 0"
      ></Pagination>
    </section>
  </div>
</template>

<script>
import { RersouceStudyRecord } from "@/api/tearcher";
export default {
  data() {
    return {
      rersouceStudyRecordArr: [], // 某学员资源学习情况列表
      currentPage2: 1, //当前页数
      pageSize2: 10, // 当前页条数
      total2: 11, // 总数
      schedule_resources_student_id: "", // 学习记录id
      title: "",
    };
  },
  methods: {
    // 当前页数条数改变
    changeSize2(size) {
      this.pageSize2 = size;
      this.requestCommonFn2();
    },
    // 当前页数改变
    changePage2(page) {
      this.currentPage2 = page;
      this.requestCommonFn2();
    },
    // 某学员资源学习情况列表
    requestCommonFn2() {
      RersouceStudyRecord({
        limit: this.pageSize2,
        page: this.currentPage2,
        schedule_resources_student_id: this.schedule_resources_student_id,
      }).then((res) => {
        this.rersouceStudyRecordArr = res.data.list;
        this.total2 = res.data.total;
        // 标题赋值
        let datas = res.data.schedule_resources_student;
        this.title = `资源学习记录-${datas.savename}-${datas.truename}`;
      });
    },
    createFn() {},
  },
  created() {
    this.schedule_resources_student_id = this.$route.query.schedule_resources_student_id;
    this.requestCommonFn2();
  },
};
</script>
 
<style lang = "less" scoped>
.personal_study_record {
}
</style>